import Axios from './Axios';

export const Appointment = {
  getAvailability: ({ doctorId, startDate, endDate }) => Axios.get(`search-doctors/get-availability-doctor/doctorId/${doctorId}/startDate/${startDate}/endDate/${endDate}`),
  getAppointment: () => Axios.get(`/appointment-doctor/history`),
  cancelAppointment: (values) => Axios.patch('/appointment-doctor/cancel-appointment', values),
  deleteAppointment: (values) => Axios.patch('/appointment-doctor/delete-appointment', values),
  createAppointment: (values) => Axios.post(`appointment-user/create`, values),
  blockSlot: (values) => Axios.post(`appointment-doctor/block-slots`, values),
  allblockSlot: () => Axios.get(`appointment-doctor/all-blocked-slots`), 
 createAppointmentfromDoctor: (values) => Axios.post(`appointment-doctor/create`, values),
 deleteBlockSlot: (id) =>
  Axios.delete(`/appointment-doctor/delete-block-slots`, {
    data: { id },
  }),
  updateBlockSlot: (values) => Axios.patch(`appointment-doctor/update-block-slots`, values),
  getAppointmentHistory: () => Axios.get(`/appointment-user/history`),
  createDoctorAppointment : (values) => Axios.post(`appointment-doctor/create`, values),
  patientRecords: ({ doctorId, status = 'pending', page = 1, limit = 50 }) =>
  Axios.get(`/appointment-doctor/patient-records/${doctorId}`, {
    params: {
      page,
      limit
    }
  }),
  searchAppointmentsByUser: (searchData) => Axios.post('/appointment-user/appointments-by-user', searchData)

};
